













































































































import BaseComponent from "@/components/base/BaseComponent";
import {MemberCRMDetails} from "@/store/modules/customerService";
import {Component, Prop} from 'vue-property-decorator';

@Component({})
export default class MemberDetails extends BaseComponent {

  @Prop() memberCRMDetails!: MemberCRMDetails


}
